<template>
  <v-list class="mt-5">
    <div v-for="(kLaporan, id) in Object.keys(meta.laporan || {})" :key="kLaporan">
      <v-divider v-if="id !== 0" class="my-3" />
      <v-list-item class="px-0">
        <v-list-item-avatar color="blue" size="45">
          <v-icon size="30" dark>mdi-calendar</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="py-0 px-1">
          <v-row>
            <v-col cols="12" lg="6" class="my-auto">
              <div class="caption grey--text">Kegiatan</div>
              <div class="black--text" style="font-size: 16px">
                {{ $getDeepObj(kegiatans, `${kLaporan}.label`) }}
              </div>
              <div class="indigo--text mt-1">
                {{ $getDeepObj(kegiatans, `${kLaporan}.jenis`) }}
              </div>
              <div class="orange--text mt-1 font-weight-medium">
                {{ $getDeepObj(meta, `pendampingan.${$getDeepObj(kegiatans, `${kLaporan}.pendampingan_ke`)}`) }}
              </div>
            </v-col>
            <v-col cols="12" lg="3">
              <div class="caption grey--text">Status Laporan</div>
              <div>
                <v-chip
                  dark
                  :color="
                    $isObject(laporans[kLaporan])
                      ? +laporans[kLaporan]['is_terlaksana'] === 1
                        ? Number(laporans[kLaporan] && laporans[kLaporan]['is_lengkap']) === 1
                          ? 'success'
                          : 'orange'
                        : 'blue'
                      : 'grey'
                  "
                >
                  {{
                    $isObject(laporans[kLaporan])
                      ? +laporans[kLaporan]['is_terlaksana'] === 1
                        ? Number(laporans[kLaporan] && laporans[kLaporan]['is_lengkap']) === 1
                          ? 'Lengkap'
                          : 'Belum Lengkap'
                        : 'Tidak ada Monev'
                      : 'Belum ada'
                  }}
                </v-chip>
              </div>
            </v-col>
            <v-col cols="12" lg="3" class="my-auto" v-if="akunInstansiId">
              <div>
                <v-btn
                  class="text-capitalize"
                  depressed
                  color="primary"
                  :disabled="Number(laporans[kLaporan] && laporans[kLaporan]['is_lengkap']) !== 1"
                  @click="onViewLaporan($getDeepObj(meta, `laporan.${kLaporan}.master`), kLaporan)"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Lihat Laporan
                </v-btn>
              </div>
            </v-col>
            <v-col
              cols="12"
              lg="3"
              class="my-auto"
              v-else-if="$allow('psp-pelatih-ahli-koordinator-pa-laporan.update')"
            >
              <div>
                <v-btn
                  class="text-capitalize"
                  depressed
                  color="primary"
                  :disabled="
                    (!$getDeepObj(
                      meta,
                      `laporan.${kLaporan}.jadwal.${$getDeepObj(kegiatans, `${kLaporan}.pendampingan_ke`)}`
                    ) &&
                      !$isObject(laporans[kLaporan])) ||
                      !meta.binaan
                  "
                  @click="onEditLaporan($getDeepObj(meta, `laporan.${kLaporan}.master`), kLaporan)"
                >
                  <v-icon left>
                    {{
                      meta.binaan &&
                      $getDeepObj(
                        meta,
                        `laporan.${kLaporan}.jadwal.${$getDeepObj(kegiatans, `${kLaporan}.pendampingan_ke`)}`
                      )
                        ? 'mdi-pencil'
                        : 'mdi-eye'
                    }}
                  </v-icon>
                  {{
                    meta.binaan &&
                    $getDeepObj(
                      meta,
                      `laporan.${kLaporan}.jadwal.${$getDeepObj(kegiatans, `${kLaporan}.pendampingan_ke`)}`
                    )
                      ? 'Lengkapi'
                      : 'Lihat'
                  }}
                  Laporan
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'KoordinatorFspLaporan2024',
  props: {
    status: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    laporans: {
      type: Object,
      default: () => {},
    },
    form: {
      type: String,
      default: '',
    },
    akunInstansiId: {
      default: '',
    },
    masterInstrumen: {
      type: String,
      default: '',
    },
    pendampinganTahun: {
      type: [String, Number],
      default: 2022,
    },
  },
  data() {
    return {
      kegiatans: {
        5: {
          label: 'Monev Implementasi Program Sekolah Penggerak Termin 1',
          jenis: 'Sekolah dengan kendala',
          pendampingan_ke: 1,
        },
        6: {
          label: 'Monev Implementasi Program Sekolah Penggerak Termin 1',
          jenis: 'Sekolah dengan praktik baik',
          pendampingan_ke: 1,
        },
        7: {
          label: 'Monev Implementasi Program Sekolah Penggerak Termin 2',
          jenis: 'Sekolah dengan kendala',
          pendampingan_ke: 7,
        },
        8: {
          label: 'Monev Implementasi Program Sekolah Penggerak Termin 2',
          jenis: 'Sekolah dengan praktik baik',
          pendampingan_ke: 7,
        },
      },
    };
  },
  methods: {
    ...mapActions('koordinatorFsp', ['fetchInstrumen', 'fetchFasilitator', 'fetchOpsi']),

    async onEditLaporan(master, kLaporan) {
      const instrumen = await this.fetchInstrumen({ params: { master }, reset: true });
      const fasilitators = await this.fetchFasilitator();
      const opsis = await this.fetchOpsi();

      this.$emit('laporan', {
        kLaporan,
        instrumen,
        fasilitators,
        opsis,
        kegiatans: this.kegiatans,
        form: this.form,
        isPreview: !(
          this.meta.binaan &&
          this.$getDeepObj(
            this.meta,
            `laporan.${kLaporan}.jadwal.${this.$getDeepObj(this.kegiatans, `${kLaporan}.pendampingan_ke`)}`
          )
        ),
      });
    },

    async onViewLaporan(master, kLaporan) {
      const instrumen = await this.fetchInstrumen({ params: { master }, reset: true });
      const opsis = await this.fetchOpsi();

      this.$emit('laporan', {
        kLaporan,
        instrumen,
        opsis,
        kegiatans: this.kegiatans,
        form: this.form,
        isPreview: true,
      });
    },
  },
};
</script>

<style scoped></style>
